import React, { useEffect, useState } from "react"
import PropTypes from "prop-types";
import { Row, Col, Card } from "reactstrap"

import { withTranslation } from "react-i18next"
//Import Image
import features from "assets/images/crypto/features-img/img-1.png"
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { viewProfile } from "store/actions";

const WelcomeComp = props => {
  const [profileData, setProfileData] = useState();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(viewProfile('auth/me', (data) => {
      setProfileData(data?.data)
    }));
  }, [dispatch]);
  return (
    <React.Fragment>
      <Card className="bg-dash">
        <div className="monthly-earning-chart">
          <Row>
            <Col lg="12">
              <div className="p-4">
                <h5 className="text-primary">Welcome Back ! <Link to={'/profile'}>{profileData?.first_name} {profileData?.last_name}</Link></h5>
                <p>Institute on Governance Dashboard</p>
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </React.Fragment>
  )
}
// export default WelcomeComp

WelcomeComp.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(WelcomeComp);
